const config = {
    apiUrl:'https://ksrapi.cloudgentechnologies.com'

}
export default config;